
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cupones",
      function () {
        return require("private-next-pages/cupones.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cupones"])
      });
    }
  